import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Something_went_wrong, Request_Thank_You } from "@root/app.constant";
import { Urls } from "../../../utils/urls";
import { ApiService } from "../../../shared/services/api.service";
import { CommonDataService } from "../../../shared/services/common-data.service";
import { NgForm } from '@angular/forms';

@Component({
  selector: "app-write-us",
  templateUrl: "./write-us.component.html",
  styleUrls: ["./write-us.component.scss"],
})
export class WriteUsComponent implements OnInit {
  userData: any = {};
  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";
  alphaPattern = "^[a-zA-Z ]*$";
  msgPattern = "^[a-zA-Z\\,\\.\\_\\;\\- ]*$";
  firstName!: string;
  lastName!: string;
  cityList = [
    {
      displayName: "Bangalore",
      value: 1,
      cityName: 'Bangalore'
    },
    {
      displayName: "Mumbai",
      value: 2,
      cityName: 'Mumbai'
    },
  ];
  reasonList = [
    {
      displayName: "Test",
      value: 1,
    },
    {
      displayName: "Test2",
      value: 2,
    },
  ];
  constructor(
    public activeModal: NgbActiveModal,
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) { }

  ngOnInit() {
    this.getCity();
    this.getReasons();
  }

  getCity = () => {
    this.apiService
      .postData(Urls.getCity, { stateId: 0 })
      .subscribe((response: any) => {
        this.cityList = response.data.cityList;
        console.log("City", this.cityList);
      });
  };

  getReasons = () => {
    this.apiService.getData(Urls.getReasons).subscribe((response: any) => {
      this.reasonList = response.data.reasons;
    });
  };

  processForm = () => {
    this.userData.name = this.firstName + " " + this.lastName;

    this.apiService
      .postData(
        Urls.postWriteUs,
        this.commonDataService.convertToString(this.userData)
      )
      .subscribe((response: any) => {
        if (response.status === 0) {
          this.toastr.success(Request_Thank_You);
        } else {
          this.toastr.error(Something_went_wrong);
        }
        this.activeModal.close();
      });
  };

  focusFirstInvalidField(): void {
  const firstInvalid = document.querySelector(
    'input.ng-invalid, select.ng-invalid, textarea.ng-invalid'
  ) as HTMLElement;

  if (firstInvalid) {
    firstInvalid.focus();
  }
}

onSubmit(form: NgForm): void {

  if (form.invalid) {
    this.focusFirstInvalidField();
    return;
  }

  this.processForm();
}

  closePopUp = () => {
    this.activeModal.close();
  };
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
